import { TextAreaField } from '@aws-amplify/ui-react'
import { Close, ContentCopyOutlined } from '@mui/icons-material'
import { DialogActions, DialogContent } from '@mui/material'
import { useTranslation } from 'react-i18next'

import CustomDialog from '@/components/feedback/CustomDialog'
import CustomButton from '@/components/inputs/CustomButton'
import { useAlertContext } from '@/contexts/AlertContext'

type LastEnergyBidTsvDialogProps = Readonly<{
  open: boolean
  onClose: () => void
  tsvContent: string
  deliveryDay: string
  marketProgram: string
}>

export function LastEnergyBidTsvDialog({
  open,
  onClose,
  tsvContent,
  deliveryDay,
  marketProgram,
}: LastEnergyBidTsvDialogProps) {
  const { t } = useTranslation()
  const { pushAlert } = useAlertContext()

  const onCopyButtonClick = async () => {
    await navigator.clipboard.writeText(tsvContent)

    pushAlert({
      message: t('bidding.import_energy_offer.retrieve_last_bid.copied_to_clipboard'),
      severity: 'success',
    })
  }

  return (
    <CustomDialog
      open={open}
      size="large"
      title={t('bidding.import_energy_offer.retrieve_last_bid.dialog_title', { date: deliveryDay, marketProgram })}
      onClose={onClose}
    >
      <DialogContent>
        <TextAreaField isReadOnly label="" resize="vertical" rows={15} value={tsvContent} />
      </DialogContent>
      <DialogActions>
        <CustomButton
          color="primary"
          fullWidth={false}
          startIcon={<ContentCopyOutlined />}
          variant="outlined"
          onClick={onCopyButtonClick}
        >
          {t('bidding.import_energy_offer.retrieve_last_bid.copy_to_clipboard')}
        </CustomButton>
        <CustomButton color="primary" fullWidth={false} startIcon={<Close />} variant="outlined" onClick={onClose}>
          {t('common.button.close')}
        </CustomButton>
      </DialogActions>
    </CustomDialog>
  )
}
